import { COOKIE_KEYS, WEB_VIEW_EVENTS } from '../../constants/app-constants';
import { AuthService, C24UserService, C2bOmsService } from '../../services';
import { proxyAuthState } from '../../services/user-auth-api';
import deleteCookie from '../../utils/helpers/delete-cookie';
import saveCookie from '../../utils/helpers/save-cookie';
import { sendWebviewEvent } from '../../utils/helpers/webview-event';
import { resetUser, setUser } from '../user/action';
import jwtDecode from 'jwt-decode';

const sendOTP = (mobile, country) => () => {
    return new Promise((resolve, reject) => {
        AuthService.sendOTP(mobile, country)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

const verifyOtp = (params, country) => () => {
    return new Promise((resolve, reject) => {
        AuthService.verifyOTP(params, country)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

const enlistDealers = (payload) => () => {
    return new Promise((resolve, reject) => {
        C2bOmsService.enlistDealer(payload)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

const setLoginInfo = ({ token, user }, dispatch) => {
    proxyAuthState.accessToken = token;
    proxyAuthState.isLoggedIn = true;
    dispatch(setUser({ ...user, access_token: token, ...(jwtDecode(token) || {}) }));
    saveCookie(COOKIE_KEYS.ACCESS_TOKEN, token);
};

const resetLoginInfo = () => {
    proxyAuthState.accessToken = null;
    proxyAuthState.isLoggedIn = false;
};

const validateToken = (token) => (dispatch) => {
    return new Promise((resolve, reject) => {
        C24UserService.getCurrentUser(token).then((response) => {
            setLoginInfo({ token, user: response.data }, dispatch);
            resolve({ ...response.data, access_token: token });
        }).catch(error => {
            resetLoginInfo();
            reject(error);
        });
    });
};

const logoutUser = () => dispatch => {
    return new Promise((resolve, reject) => {
        try {
            sendWebviewEvent({ data: {}, type: WEB_VIEW_EVENTS.LOGOUT });
            dispatch(resetUser());
            deleteCookie(COOKIE_KEYS.ACCESS_TOKEN);
            proxyAuthState.accessToken = null;
            proxyAuthState.isLoggedIn = false;
            resolve({});
        } catch (error) {
            reject(error);
        }
    });
};

const fetchDealer = (dealerCode) => () => {
    return new Promise((resolve, reject) => {
        C2bOmsService.fetchDealerByCode(dealerCode)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

export {
    sendOTP,
    verifyOtp,
    enlistDealers,
    logoutUser,
    validateToken,
    fetchDealer
};
